import { makeStyles, Typography } from "@material-ui/core";
import { Alert, AlertTitle } from "ra-friendsofbabba";
import React from "react";
import { useTranslate } from "react-admin";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  message: {
    width: "100%",
  },
}));

const ContractMonthsAlert = () => {
  const classes = useStyles();
  const translate = useTranslate();
  return (
    <Alert elevation={1} severity="info" className={classes.root}>
      <AlertTitle>
        {translate("resources.user-breaks.alert.contract_months.title")}
      </AlertTitle>
      <Typography variant="body1" className={classes.message}>
        <span
          dangerouslySetInnerHTML={{
            __html: translate(
              `resources.user-breaks.alert.contract_months.message`
            ),
          }}
        />
      </Typography>
    </Alert>
  );
};
export default ContractMonthsAlert;
